<template>
  <div class="package-list-item">
    <img :src="imageUrl" class="image" />
    <div class="meta">
      <router-link :to="route" class="name">{{ name }}</router-link>
      <p class="desc">{{ desc }}</p>
      <p class="desc">
        <span v-if="originalPrice" class="original-price">{{ originalPriceText }}</span>
        {{ priceText }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  convertBathToStangAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString
} from "@/lib/formatter";

export default {
  props: {
    imageUrl: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    target: {
      type: String,
      default: ""
    },
    detail: {
      type: String,
      default: ""
    },
    price: {
      type: Number,
      default: 0
    },
    billingCycle: {
      type: [Number, String],
      default: null
    },
    route: {
      type: Object,
      default: () => ({})
    },
    originalPrice: {
      type: Number,
      default: null
    }
  },
  computed: {
    desc() {
      let detail
      try {
        detail = JSON.parse(this.detail).ops
        detail = this.quillToPlaintext(detail)
      } catch (e) {
        detail = this.detail || ""
      }

      return `${this.target} — ${detail}`;
    },
    originalPriceText() {
      if (!this.originalPrice) {
        return "";
      }

      return `${formatCurrencyAndTwoDecimalsString(this.originalPrice / 100)  } บาท`;
    },
    priceText() {
      const baht = formatCurrencyAndTwoDecimalsString(convertBathToStangAndRoundTwoDecimal(this.price));
      const isMonthly = Number(this.billingCycle) === 1;
      const months = isMonthly ? "" : `${this.billingCycle} `;

      return `${baht} บาท / ${months}เดือน`;
    }
  },
  methods: {
    quillToPlaintext(delta) {
      return delta.reduce((text, op) => {
        if (!op.insert) throw new TypeError('only `insert` operations can be transformed!')
        if (typeof op.insert !== 'string') return `${text} `
        return text + op.insert;
      }, '')
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 120px;

.package-list-item {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;

  align-items: center;

  border-bottom: $border;
  padding: ($space / 2) $space;

  > .image {
    display: block;

    border-radius: 8px;
    width: $logoSize;
    height: 90px;
    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: $space;
    display: block;

    flex-grow: 1;
  }
}

.meta {
  margin-top: -4px;
  min-width: 0;

  > .name {
    display: inline-block;
    font-size: 1rem;

    &:hover {
      color: black;
    }
  }

  > .desc {
    overflow: hidden;
    height: 23px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta p {
  line-height: 1.6;
  font-size: 0.9rem;
  color: #777;
}

.provider {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .logo {
    margin-right: 12px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}

.original-price {
  text-decoration: line-through;
}
</style>
